<template>
    <div class="login-content">
        <h1 class="mb-2">Dewhot Product Warranty Portal</h1>
        <p class="mb-5">
            Please register on our system and load your products into<br />
            your profile so that we can activate the warranties and<br />
            offer you seamless after sales support
        </p>
        <button type="button" @click.prevent="callback" class="btn btn-primary btn-rounded-lg px-4 py-2">Click here to register</button>

        <h4 class="mt-5">Already registered, login here</h4>
        <div class="login-form-wrapper mt-2">
            <div class="input-wrapper">
                <input type="text" v-model="form.email" name="email" placeholder="Email" />
            </div>
            <div class="input-wrapper">
                <input type="password" v-model="form.password" name="password" placeholder="Password" />
            </div>
            <div class="submit-wrapper">
                <button type="button" @click.prevent="login()" class="btn btn-secondary btn-rounded">login</button>
            </div>
        </div>
        <forgot-pass-form></forgot-pass-form>
    </div>
</template>

<script>
import ForgotPassForm from '@/views/pageComponents/login/ForgotPassword';
import {mapGetters, mapActions} from 'vuex';
import Helpers from '@/helpers/index';

export default {
    name: 'loginForm',
    components: {
        ForgotPassForm
    },
    props: {
        callback: {type: Function}
    },
    data() {
        return {
            form: {
                email: '',
                password: '',
                app_path: window.location.href
            }
        };
    },
    computed: {
        ...mapGetters({
            vg_token: 'auth/token'
        })
    },
    mounted() {
        if (this.$route.query.refresh) {
            window.location = window.location.href.split('?')[0];
        }
        // let pubnub = PubNubVue.getInstance();
        // console.log(pubnub)
    },
    methods: {
        async login() {
            this.spinner(true);
            let res = await this.va_setUser(this.form);
            this.spinner(false);
            if (res.status && res.status == 200) {
                this.form.email = '';
                this.form.password = '';
                this.va_setMainProduct(res.data.product_data);
                this.va_setMainProductGroup(res.data.product_grouped_data);
                // push depending on role
                let userRole = res.data.payload.role;
                let nameRoute = '';
                if (userRole == 'superadmin') {
                    nameRoute = 'SuperadminDashboard';
                } else if (userRole == 'distributor') {
                    nameRoute = 'DistributorDashboard';
                } else if (userRole == 'reseller') {
                    nameRoute = 'ResellerDashboard';
                } else {
                    nameRoute = 'CustomerDashboard';
                }
                this.$router.push({name: nameRoute});
            }
            if (res.status == 200) {
                this.$toasted.global.success({
                    message: res.data.message
                });
            } else {
                this.$toasted.global.error({
                    message: res.response.data.errors[0]
                });
            }
        },
        ...mapActions({
            va_setUser: 'auth/setUser',
            va_setMainProduct: 'mainproduct/setMainProduct',
            va_setMainProductGroup: 'mainproduct/setMainProductGroup'
        })
    }
};
</script>
